var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{attrs:{"colspan":_vm.colspan ?? 1}},[_c('p',{staticClass:"text-center text-body-1 py-10"},[_vm._v("No records found.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }